import { createAction } from 'redux-actions'

const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
const SHOW_MESSAGE = 'SHOW_MESSAGE'

const clearMessage = createAction(CLEAR_MESSAGE)

const showMessage = createAction(SHOW_MESSAGE)

const message = (options) => {
    return (dispatch) => {
        dispatch(showMessage(options))
        setTimeout(() => {
            dispatch(clearMessage())
        }, 3000)
    }
}

const actions = {
    clearMessage,
    message,
    showMessage
}

const types = {
    CLEAR_MESSAGE,
    SHOW_MESSAGE
}

export { actions, types }



// WEBPACK FOOTER //
// ./src/store/actions/messages.js